import { Stack } from "@mui/system";
import BudgetSearchItemsCard from "./BudgetSearchItemsCard";

const BudgetSearchItems = () => {
  return (
    <>
      <Stack spacing={2}>
        <BudgetSearchItemsCard
          title="247bet Sport UK"
          brandId="2295"
          value="289"
          budget="300"
          budgetPercentage="96%"
          budgetColor="success"
          rr="299"
          rrPercentage="99%"
          rrColor="success"
        />
         <BudgetSearchItemsCard
          title="Bettom Sport UK"
          brandId="2319"
          value="210"
          budget="200"
          budgetPercentage="105%"
          budgetColor="error"
          rr="217"
          rrPercentage="109%"
          rrColor="error"
        />
         <BudgetSearchItemsCard
          title="Virgin Bet Sport UK"
          brandId="801"
          value="175"
          budget="300"
          budgetPercentage="89%"
          budgetColor="warning"
          rr="167"
          rrPercentage="96%"
          rrColor="success"
        />
      </Stack>
    </>
  );
};

export default BudgetSearchItems;
